export enum LineMatchStatus {
  afterMatched = "배정완료",
  beforeMatched = "미배정",
}
